const crypto = require('crypto');

const KEY_LENGTH = 32;

function bxor(b1, b2, n) {
  const result = Buffer.alloc(n);
  for (let i = 0; i <= n; i++) {
    result[i] = b1[i] ^ b2[i];
  }
  return result;
}

function keySplitRecursion(key, n) {
  if (n <= 1) return [key];
  const nextSplit = crypto.randomBytes(KEY_LENGTH);
  const nextKey = bxor(nextSplit, key, KEY_LENGTH);
  return [nextSplit].concat(keySplitRecursion(nextKey, n - 1));
}

function keyMergeRecursion(splits) {
  if (splits.length <= 1) return splits[0];
  const split = splits.pop(); //  Removes last element from splits array
  // Note = the above operation MUST reduce the array size or the recursion will never end.
  return bxor(split, keyMergeRecursion(splits), KEY_LENGTH);
}

function keySplit(key, n = 1) {
  if (!(key instanceof Uint8Array))
    throw Error('ERROR in keySplit - key is not an unsigned byte array');
  if (!(n > 0)) throw Error('ERROR in keySplit - n is not a positive integer');
  return keySplitRecursion(key, n);
}

function keyMerge(splits) {
  if (!Array.isArray(splits)) throw Error('ERROR in keyMerge - splits is not an array');
  if (splits.length < 1) throw Error('ERROR in keyMerge - splits must have at least one element');
  return keyMergeRecursion(splits.slice()); // make a copy since this recursion is destructive
}

module.exports = {
  keySplit,
  keyMerge,
};
